import classNames from 'classnames';
import { Slot } from '@radix-ui/react-slot';

export function Section({
  children,
  className,
  as = 'section',
  asChild,
}: {
  children: React.ReactNode;
  className?: string;
  as?: 'section' | 'div' | 'header' | 'footer';
  asChild?: boolean;
}) {
  const Comp = asChild ? Slot : as;
  return <Comp className={classNames('section', className)}>{children}</Comp>;
}
